import classNames from 'classnames'
import React, { ForwardedRef, useState } from 'react'
import { InputLabel, FormControl, FormControlProps, FormHelperText } from 'ui'

import { Select, SelectProps } from './Select'
import style from './SelectDropdown.module.scss'

export interface ISelectDropdown {
  children: React.ReactNode
  selectProps: SelectProps
  formControlProps?: FormControlProps
  icon?: React.ReactNode
  helperText?: string
  low?: boolean
  ref?: ForwardedRef<HTMLSelectElement> | undefined
}

export const SelectDropdown = React.forwardRef<
  HTMLSelectElement,
  ISelectDropdown
>(({ children, formControlProps, selectProps, icon, helperText, low }, ref) => {
  const [shrinkValue, setShrinkValue] = useState(false)
  return (
    <FormControl {...formControlProps}>
      {selectProps.label && (
        <InputLabel
          className={classNames({
            hasSelectIcon: !!icon,
            low,
          })}
          shrink={shrinkValue || Boolean(selectProps.value)}
        >
          {selectProps.label}
          {selectProps.required && ' *'}
        </InputLabel>
      )}
      {icon && <div className={style.icon}>{icon}</div>}
      <Select
        {...selectProps}
        ref={ref}
        onOpen={(event: React.SyntheticEvent<Element, Event>) => {
          // eslint-disable-next-line @typescript-eslint/no-unused-expressions
          selectProps.onOpen && selectProps.onOpen(event)
          setShrinkValue(true)
        }}
        onBlur={(
          event: React.FocusEvent<
            HTMLInputElement | HTMLTextAreaElement,
            Element
          >,
        ) => {
          // eslint-disable-next-line @typescript-eslint/no-unused-expressions
          selectProps.onBlur && selectProps.onBlur(event)
          setShrinkValue(false)
        }}
        className={classNames(style.select, {
          hasIcon: !!icon,
          isSelected: !!selectProps.value,
          low,
        })}
      >
        {children}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  )
})
